import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../api/client';
import { useAuth } from './AuthContext';

const WarehouseContext = createContext();

export function WarehouseProvider({ children }) {
  const { admin } = useAuth();
  const [warehouses, setWarehouses] = useState([]);
  // Сессионный override: если пользователь в текущей сессии вручную переключил склад через селектор в шапке.
  // Сбрасывается при входе/выходе и при смене default_warehouse_id в профиле.
  const [sessionOverride, setSessionOverride] = useState(null);
  const [selectedWarehouseId, setSelectedWarehouseId] = useState('');

  const fetchWarehouses = () => {
    if (!admin) return;
    api.get('/warehouses').then(r => {
      setWarehouses(r.data);
      const ids = r.data.map(w => String(w.id));
      // Приоритет: сессионный выбор → default_warehouse_id из профиля → "Все склады"
      if (sessionOverride !== null) {
        // "" = явно "Все склады"
        if (sessionOverride === '' || ids.includes(sessionOverride)) {
          setSelectedWarehouseId(sessionOverride);
          return;
        }
      }
      if (admin.default_warehouse_id && ids.includes(String(admin.default_warehouse_id))) {
        setSelectedWarehouseId(String(admin.default_warehouse_id));
      } else {
        setSelectedWarehouseId('');
      }
    }).catch(() => {});
  };

  // Сброс сессионного override при смене пользователя или смене default_warehouse_id
  useEffect(() => { setSessionOverride(null); }, [admin?.id, admin?.default_warehouse_id]);
  useEffect(() => { fetchWarehouses(); }, [admin?.id, admin?.default_warehouse_id, sessionOverride]);

  const selectWarehouse = (id) => {
    const val = id === null || id === undefined ? '' : String(id);
    setSessionOverride(val);
  };

  const selectedWarehouse = selectedWarehouseId
    ? warehouses.find(w => String(w.id) === selectedWarehouseId) || null
    : null;

  return (
    <WarehouseContext.Provider value={{
      warehouses,
      selectedWarehouse,
      selectedWarehouseId: selectedWarehouseId || '',
      selectWarehouse,
      fetchWarehouses
    }}>
      {children}
    </WarehouseContext.Provider>
  );
}

export function useWarehouse() { return useContext(WarehouseContext); }
